export const SET_DELAY = "SET_DELAY";

export function isHideDelay(store) {
  store.on("@init", () => ({ isHideDelay: false }));

  store.on(SET_DELAY, ({ isHideDelay }) => {
    return { isHideDelay: !isHideDelay };
  });
}
